'kiwi public';

import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _ from 'lodash';
import * as Misc from '@/helpers/Misc';
import StartupLayout from './CommonLayout';
export default {
  components: {
    StartupLayout: StartupLayout
  },
  data: function data() {
    return {
      connectErrors: [],
      network: null,
      network_extras: null,
      username: '',
      password: '',
      znc_network: '',
      showNetwork: true,
      showPass: true,
      showUser: true,
      show_password_box: false
    };
  },
  computed: {
    greetingText: function greetingText() {
      var greeting = this.$state.settings.startupOptions.greetingText;
      return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
    },
    buttonText: function buttonText() {
      var greeting = this.$state.settings.startupOptions.buttonText;
      return typeof greeting === 'string' ? greeting : this.$t('start_button');
    },
    readyToStart: function readyToStart() {
      return this.username && (this.password || this.showPass === false);
    },
    infoContent: function infoContent() {
      return this.$state.settings.startupOptions.infoContent || '';
    }
  },
  created: function created() {
    var options = this.$state.settings.startupOptions;
    this.username = options.username || '';
    this.password = options.password || '';
    this.znc_network = window.location.hash.substr(1) || options.network || '';
    this.showNetwork = typeof options.showNetwork === 'boolean' ? options.showNetwork : true;
    this.showUser = typeof options.showUser === 'boolean' ? options.showUser : true;
    this.showPass = typeof options.showPass === 'boolean' ? options.showPass : true;
    if (options.autoConnect && this.username && this.password) {
      this.startUp();
    }
    window.test = this;
  },
  methods: {
    readableStateError: function readableStateError(err) {
      return Misc.networkErrorMessage(err);
    },
    formSubmit: function formSubmit() {
      if (this.readyToStart) {
        this.startUp();
      }
    },
    addNetwork: function addNetwork(netName) {
      var options = this.$state.settings.startupOptions;
      var password = this.username;
      if (netName) {
        password += '/' + netName;
      }
      password += ':' + this.password;
      var net = this.$state.addNetwork(netName, 'ZNC', {
        server: _trimInstanceProperty(_).call(_, options.server),
        port: options.port,
        tls: options.tls,
        password: password
      });
      return net;
    },
    startUp: function startUp() {
      var _this = this;
      this.connectErrors = [];
      if (this.network) {
        this.$state.removeNetwork(this.network.id);
      }
      var netList = _.compact(this.znc_network.split(','));
      if (netList.length === 0) {
        netList.push('');
      }

      // add our first network and make sure we can connect
      // before trying to add other networks.
      var net = this.network = this.addNetwork(netList.shift());
      this.network_extras = netList;
      var _onRegistered = function onRegistered() {
        _this.$state.setActiveBuffer(net.id, net.serverBuffer().name);
        if (_this.$refs.layout) {
          _this.$refs.layout.close();
        }
        net.ircClient.off('registered', _onRegistered);
        net.ircClient.off('close', _onClosed);
        net.ircClient.off('irc error', onError);
        _this.network_extras.forEach(function (netName, idx) {
          var extraNet = _this.addNetwork(_trimInstanceProperty(_).call(_, netName));
          extraNet.ircClient.connect();
        });
      };
      var _onClosed = function onClosed() {
        var _context;
        var lastError = _this.network.last_error;
        if (lastError && !_includesInstanceProperty(_context = _this.connectErrors).call(_context, lastError)) {
          _this.connectErrors.push(lastError);
        }
        if (!_this.connectErrors.length && !net.state_error) {
          _this.connectErrors.push(_this.$t('error_closed_unexpected'));
        }
        net.ircClient.off('registered', _onRegistered);
        net.ircClient.off('close', _onClosed);
        net.ircClient.off('irc error', onError);
      };
      var onError = function onError(event) {
        var _context2;
        if (event.reason && !_includesInstanceProperty(_context2 = _this.connectErrors).call(_context2, event.reason)) {
          _this.connectErrors.push(event.reason);
        }
      };
      net.ircClient.once('registered', _onRegistered);
      net.ircClient.once('close', _onClosed);
      net.ircClient.on('irc error', onError);
      net.ircClient.connect();
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["ZncLogin"]
window._kiwi_exports.components.startups.ZncLogin = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
